module.exports = __webpack_public_path__ + "static/media/CC10-QUICK.390d447c.png";